<!-- Numbers variant -->
@if (variant === 'numbers') {
    <nav class="ccl-pagination" role="navigation" aria-label="Pagination">
      <button
        class="ccl-pagination__btn"
        [disabled]="currentPage === 1"
        (click)="prevPage()"
        aria-label="Go to previous page"
      >
        ‹
      </button>
  
      @if (showFirstLast) {
        <button
          class="ccl-pagination__btn"
          [disabled]="currentPage === 1"
          (click)="goToPage(1)"
          aria-label="Go to first page"
        >
          «
        </button>
      }
  
      @for (page of pages; track page) {
        <button
          class="ccl-pagination__btn"
          [class.active]="page === currentPage"
          (click)="goToPage(page)"
          [attr.aria-current]="page === currentPage ? 'page' : null"
          [attr.aria-label]="'Go to page ' + page"
        >
          {{ page }}
        </button>
      }
  
      @if (showFirstLast && totalPages) {
        <button
          class="ccl-pagination__btn"
          [disabled]="currentPage === totalPages"
          (click)="goToPage(totalPages!)"
          aria-label="Go to last page"
        >
          »
        </button>
      }
  
      <button
        class="ccl-pagination__btn"
        [disabled]="totalPages && currentPage === totalPages"
        (click)="nextPage()"
        aria-label="Go to next page"
      >
        ›
      </button>
    </nav>
  }
  
  <!-- Load more variant -->
  @if (variant === 'load-more') {
    <div class="ccl-pagination__load-more">
      <button
        class="ccl-pagination__btn"
        (click)="loadMore()"
        aria-label="Load more items"
      >
        Load More
      </button>
    </div>
  }
  
  <!-- Detailed variant -->
  @if (variant === 'detailed') {
    <div class="ccl-pagination-detailed-inline" role="navigation" aria-label="Pagination">
      <!-- Prev button (customizable) -->
      @if (prevButtonTemplate) {
        <ng-container [ngTemplateOutlet]="prevButtonTemplate" [ngTemplateOutletContext]="{ disabled: currentPage === 1, click: prevPage.bind(this) }"></ng-container>
      } @else {
        <button class="ccl-pagination__btn" [disabled]="currentPage === 1" (click)="prevPage()" aria-label="Go to previous page">‹</button>
      }

      <!-- Range text -->
      <div class="ccl-pagination-detailed-inline__range">
        @if (totalItems != null && rangeStart != null && rangeEnd != null) {
          <span>{{ rangeStart }} - {{ rangeEnd }} of {{ totalItems }}</span>
        }
      </div>

      <!-- Next button (customizable) -->
      @if (nextButtonTemplate) {
        <ng-container [ngTemplateOutlet]="nextButtonTemplate" [ngTemplateOutletContext]="{ disabled: totalPagesResolved && currentPage === totalPagesResolved, click: nextPage.bind(this) }"></ng-container>
      } @else {
        <button class="ccl-pagination__btn" [disabled]="totalPagesResolved && currentPage === totalPagesResolved" (click)="nextPage()" aria-label="Go to next page">›</button>
      }

      <!-- Records per page selector -->
      <div class="ccl-pagination-detailed-inline__size">
        <label class="ccl-pagination-detailed__size-label" for="ccl-page-size">Records per page</label>
        <select id="ccl-page-size" class="ccl-pagination-detailed__size-select" [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          @for (opt of pageSizeOptions; track opt) {
            <option [value]="opt">{{ opt }}</option>
          }
        </select>
      </div>
    </div>
  }
  